import { AppEnvironments } from "@ipg/ngx-frontend-toolset";

export const environment = {
    activeEnvironment: AppEnvironments.STAG
};
